import type { ReactElement } from 'react';

export type IconName =
  | 'menu'
  | 'close'
  | 'sun'
  | 'moon'
  | 'building'
  | 'users'
  | 'overview'
  | 'equipment'
  | 'requests'
  | 'warehouse'
  | 'catalog'
  | 'stock'
  | 'construction'
  | 'chevron-down'
  | 'eye'
  | 'search'
  | 'eye-off'
  | 'document'
  | 'tracker';

function iconPath(name: IconName): string {
  const paths: Record<IconName, string> = {
    menu: 'M4 6h16M4 12h16M4 18h16',
    close: 'm6 6 12 12M6 18 18 6',
    sun: 'M12 3v2m0 14v2M3 12h2m14 0h2M5.6 5.6 7 7m10 10 1.4 1.4M5.6 18.4 7 17m10-10 1.4-1.4M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z',
    moon: 'M20 14.4A8.5 8.5 0 0 1 9.6 4a8.5 8.5 0 1 0 10.4 10.4Z',
    building: 'M4 21V5l8-2v18M12 9h8v12M8 7v1m0 3v1m0 3v1m8-3v1m0 3v1M2 21h20',
    users:
      'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2m20 0v-2a4 4 0 0 0-3-3.9M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm4-3.9a4 4 0 0 1 0 7.8',
    overview: 'm3 10 9-7 9 7v10H3V10Zm6 10v-7h6v7',
    equipment:
      'M3 16V9h8v7m0-4h5l3 4h2v3h-2m-8 0H8M5 8V5h5M8 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm11 1a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z',
    requests: 'M8 4H5v17h14V4h-3M8 3h8v4H8V3Zm0 9h8m-8 4h5',
    warehouse: 'm3 9 9-6 9 6v12H3V9Zm4 12v-8h10v8M7 17h10',
    catalog: 'M3 3h7v7H3V3Zm11 0h7v7h-7V3ZM3 14h7v7H3v-7Zm11 0h7v7h-7v-7Z',
    stock: 'M3 7h17m-4-4 4 4-4 4M21 17H4m4-4-4 4 4 4',
    construction:
      'M12 21s-7-6.2-7-11a7 7 0 1 1 14 0c0 4.8-7 11-7 11Zm3-11a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
    'chevron-down': 'm6 9 6 6 6-6',
    document: 'M14 3H6v18h12V7l-4-4Zm0 0v4h4M9 12h6m-6 4h6',
    tracker:
      'M12 2v3m0 14v3M2 12h3m14 0h3M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-4 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
    search: 'm21 21-5-5M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z',
    eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Zm13 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
    'eye-off':
      'm3 3 18 18M10.6 5.1 12 5c6.5 0 10 7 10 7a19 19 0 0 1-3 3.7M6.3 6.3A20 20 0 0 0 2 12s3.5 7 10 7a11 11 0 0 0 5.7-1.7M9.9 9.9a3 3 0 0 0 4.2 4.2',
  };
  return paths[name];
}

/** Decorative line icons always accompany a visible or accessible label. */
export function Icon({ name }: { name: IconName }): ReactElement {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d={iconPath(name)}
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
